export default "/JMMMU/tech_engineering.af069cd9-2335e6.jpg";